import { Status } from '@essent/common';
import type { Consumption } from '@essent/extension-offer';
import {
  getConsumption,
  getConsumptionClear,
  getConsumptionError,
  getConsumptionSuccess,
} from '@essent/extension-offer';
import type { CollectionState } from '@innogy/utils-state';
import {
  createInitialCollectionState,
  updateCollectionState,
} from '@innogy/utils-state';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

export type ConsumptionState = CollectionState<Consumption[]>;

const initialState: ConsumptionState = createInitialCollectionState();

const _consumptionReducer = createReducer(
  initialState,
  on(getConsumption, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.PENDING,
    })
  ),
  on(getConsumptionSuccess, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.SUCCESS,
      entry: action.payload,
    })
  ),
  on(getConsumptionError, (state, action) =>
    updateCollectionState(state, action, {
      status: Status.ERROR,
      error: action.payload,
    })
  ),
  on(getConsumptionClear, (_) => initialState)
);

export function consumptionReducer(
  state: ConsumptionState = initialState,
  action: Action
): ConsumptionState {
  return _consumptionReducer(state, action);
}
